import { recaptchaUpdater } from '../../modules/recaptcha';

export const profilesPersonal = () => {
  recaptchaUpdater('profile');
};
